import axios from "axios";
import { BASE_URL } from "./urls";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 230000,
});

// ---------------- REQUEST INTERCEPTOR ----------------
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// ---------------- RESPONSE INTERCEPTOR ----------------
apiClient.interceptors.response.use(
  (response) => {
    // For file downloads return full response
    if (response.config.responseType === "blob") {
      return response;
    }

    return response.data;
  },
  async (error) => {
    console.error("API Error:", error);

    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem("authToken");
    }

    if (status === 500) {
      console.error("Internal Server Error");
    }

    // Voice-provider calls need the status and body so 409/422 can map to fields.
    if (error.config?.preserveError) {
      return Promise.reject({
        status,
        data: error.response?.data,
      });
    }

    const res = error.response;

    // Handle blob error responses (file download endpoints)
    if (res?.data instanceof Blob) {
      try {
        const text = await res.data.text();
        const payload = JSON.parse(text);

        return Promise.reject(
          payload?.detail || payload?.message || payload || "An error occurred",
        );
      } catch {
        return Promise.reject("An error occurred");
      }
    }

    // Handle normal JSON errors
    const errorMessage =
      res?.data?.detail ||
      res?.data?.message ||
      res?.data?.error ||
      error.message ||
      "An error occurred";

    return Promise.reject(errorMessage);
  },
);

export default apiClient;
